import Image from 'next/image'
import { FC, useEffect, useRef } from 'react'

import { SkeletonLoader } from '@/shared/lib/components/SkeletonLoader/SkeletonLoader'
import { BASE_URL } from '@/shared/lib/const/env'
import { useIntersection } from '@/shared/lib/hooks/useIntersection'
import { useMediaQueries } from '@/shared/lib/hooks/useMediaQueries'

import { BannerData } from '../types/types'

import cl from './catalog-banner.module.scss'

export type CatalogBannerProps = {
	data: BannerData
	onIntersection?: (data: BannerData) => void
	onClick?: (data: BannerData) => void
	isLoading?: boolean
	desktopHeight?: number
}

const MOBILE_BANNER_HEIGHT = 75
const MAX_BANNER_WITH = 1400

/**
 * Catalog image with link
 *
 * @param props
 * @param props.imgSrcMob
 * @param props.imgSrcMob
 * @param props.href
 *
 * */
export const CatalogBanner: FC<CatalogBannerProps> = ({
	data,
	desktopHeight = 75,
	onIntersection,
	onClick,
	isLoading
}) => {
	const bannerRef = useRef(null)
	const inViewport = useIntersection(bannerRef, { rootMargin: `-100px` }, true)

	const { isMobile } = useMediaQueries()

	useEffect(() => {
		if (inViewport && onIntersection) {
			onIntersection(data)
		}
	}, [inViewport, data, onIntersection])

	const onClickHandler = (): void => {
		if (onClick) {
			onClick(data)
		}
		window.open(data.link, `_blank`)
	}

	const IMG_HEIGHT = isMobile ? MOBILE_BANNER_HEIGHT : desktopHeight

	if (isLoading || !data) {
		return <SkeletonLoader height={IMG_HEIGHT} width="100%" borderRadius={8} className={cl.catalogBanner} />
	}

	const { link, mobSrc, src } = data

	if (!mobSrc && !src) return null

	return (
		<div
			ref={bannerRef}
			onClick={link ? onClickHandler : null}
			className={cl.catalogBanner}
			style={{
				height: `${IMG_HEIGHT}px`
			}}>
			<Image
				src={`${BASE_URL}${isMobile ? mobSrc : src}`}
				alt={'catalog-old banner image'}
				width={MAX_BANNER_WITH}
				height={IMG_HEIGHT}
				className={cl.img}
			/>
		</div>
	)
}
